import axios from "axios";
import {PROGRAMME_LIST_FAIL, PROGRAMME_LIST_REQUEST, PROGRAMME_LIST_SUCCESS} from "../constants/programmeConstants";

export const getProgramme = (id, date) => async (dispatch, getState) => {
    try{
        dispatch({type: PROGRAMME_LIST_REQUEST});
        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const {data} = await axios.get(`/api/programmes/${id}/${date}`, config);
        //console.log(data);
        dispatch({type: PROGRAMME_LIST_SUCCESS, payload: data});
    }
    catch (error){
        dispatch({
            type: PROGRAMME_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}
